const insurers = `
query insurers($tenantId: String!){
  insurers(tenantId: $tenantId){
    id
    name
  }
}
`

const products = `
query products($skip: Int, $limit: Int, $sort: sortInput $where: productWhereInput){
  products_2(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      createdAt
      name
      productId{
        plan
        type
        version
      }
      insurer{
        id
        name
        logoUrls{
          typeC
        }
      }
    }
  }
}
`

const users = `
query internals($skip: Int, $limit: Int, $sort: sortInput, $where:internalWhereInput){
  internals(skip: $skip, limit: $limit, sort: $sort, where:$where){
    totalCount
    list{
      id
      name
      internalCode
      isActive
      associatedLogin{
        id
        email
      }
    }
  }
}
`

const internals = `
query internals($skip: Int, $limit: Int, $sort: sortInput, $where:internalWhereInput){
  internals(skip: $skip, limit: $limit, sort: $sort, where:$where){
    totalCount
    list{
      id
      createdAt
      createdBy{ associatedUser { id name } }
      lastModifiedAt
      lastModifiedBy{ associatedUser { id name } }
      name
      internalCode
      isActive
    }
  }
}
`

const organizations = `
query organizations($skip: Int, $limit: Int, $sort: sortInput, $where:organizationWhereInput){
  organizations(skip: $skip, limit: $limit, sort: $sort, where:$where){
    totalCount
    list{
      __typename
      id
      name
    }
  }
}
`

const insuranceTypes = `
query{
    productTypes{
      description
      name
      typeId
      tenantId
    }
  }
`

const permissionGroups = `
query permissionGroups{
  permissionGroups{
    id
    name
    description
    createdAt
    targettedPermissions{
      permission{
        id
        name
      }
      targetIds
    }
  }
}
`

/**
 * Notes
 */
const addPolicyNote = `
mutation addPolicyNote($policyId: String! $noteInput: addNoteInput!){
  addPolicyNote(policyId: $policyId noteInput: $noteInput){
    errors
    status
  }
}
`

const updatePolicyNote = `
mutation updateNote($policyId: String! $updateNoteInput: updateNoteInput!){
  updatePolicyNote(policyId: $policyId updateNoteInput: $updateNoteInput){
    errors
    status
  }
}
`

const deletePolicyNote = `
mutation removePolicyNote($policyId: String! $id: String!){
  removePolicyNote(policyId: $policyId id: $id){
    errors
    status
  }
}
`

const addEntityNote = `
mutation addEntityNote($entityId: String! $noteInput: addNoteInput!){
  addEntityNote(entityId: $entityId noteInput: $noteInput){
    errors
    status
  }
}
`

const updateEntityNote = `
mutation updateEntityNote($entityId: String! $updateNoteInput: updateNoteInput!){
  updateEntityNote(entityId: $entityId updateNoteInput: $updateNoteInput){
    errors
    status
  }
}
`

const deleteEntityNote = `
mutation removeEntityNote($entityId: String! $id: String!){
  removeEntityNote(entityId: $entityId id: $id){
    errors
    status
  }
}
`

const addNoteToCase = `
mutation addNoteToCase($caseId: String! $input: addNoteInput!){
  addNoteToCase(caseId: $caseId input: $input){
    errors
    status
  }
}
`

const updateNoteOfCase = `
mutation updateNoteOfCase($caseId: String! $noteId: String! $input: updateNoteInput!){
  updateNoteOfCase(caseId: $caseId noteId: $noteId input: $input){
    errors
    status
  }
}
`

const removeNoteFromCase = `
mutation removeNoteFromCase($caseId: String! $noteId: String!){
  removeNoteFromCase(caseId: $caseId noteId: $noteId){
    errors
    status
  }
}
`

/**
 * Files
 */
const deletePolicyAttachment = `
mutation removePolicyAttachment($policyId: String! $fileName: String!){
  removePolicyAttachment(policyId: $policyId fileName: $fileName){
    errors
    status
  }
}
`

const deleteEntityAttachment = `
mutation removeEntityAttachment($entityId: String! $fileName: String!){
  removeEntityAttachment(entityId: $entityId fileName: $fileName){
    errors
    status
  }
}
`

const deleteFile = `
mutation deleteFile($key: String!){
  deleteFile(key: $key){
    errors
    errors_2{
      code
      message
    }
    status
  }
}
`

const individuals = `
query individuals($skip: Int, $limit: Int, $sort: sortInput, $where: individualWhereInput){
  individuals(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list {
      id
      name
    }
  }
}
`

const companies = `
query companies($skip: Int, $limit: Int, $sort: sortInput, $where: companyWhereInput){
  companies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list {
      id
      name
    }
  }
}
`

const addContact = `
mutation addContact($entityId: String!, $contactInput: addContactInput!){
  addContact(entityId: $entityId, contactInput: $contactInput){
    status
  }
}
`
const addIdentity = `
mutation addIdentity($entityId: String! $addIdentityInput: addIdentityInput!){
  addIdentity(entityId: $entityId identityInput: $addIdentityInput){
    errors
    status
  }
}
`

const addAddress = `
mutation addAddress($entityId: String! $addressInput: addressInput!){
  addAddress(entityId: $entityId addressInput: $addressInput){
    errors
    status
  }
}
`

const addFact = `
mutation addFact($entityId: String! $factInput: addFactInput!){
  addFact(entityId: $entityId factInput: $factInput){
    errors
    status
  }
}
`

const addLink = `
mutation addLink($linkInput: createLinkInput!){
  addLink(linkInput: $linkInput){
    errors
    status
  }
}
`

const deleteContact = `
mutation deleteContact($entityId: String! $id: String!){
  deleteContact(entityId: $entityId id: $id){
    errors
    status
  }
}
`
const deleteIdentity = `
mutation deleteIdentity($entityId: String! $id: String!){
  deleteIdentity(entityId: $entityId id: $id){
    errors
    status
  }
}
`
const deleteAddress = `
mutation deleteAddress($entityId: String! $id: String!){
  deleteAddress(entityId: $entityId id: $id){
    errors
    status
  }
}
`

const deleteFact = `
mutation deleteFact($entityId: String! $id: String!){
  deleteFact(entityId: $entityId id: $id){
    errors
    status
  }
}
`

const removeLink = `
mutation removeLink($linkInput: removeLinkInput!){
  removeLink(linkInput: $linkInput){
    errors
    status
  }
}
`

const updateContact = `
mutation updateContact($entityId: String!, $updateContactInput: updateContactInput!){
  updateContact(entityId: $entityId, updateContactInput: $updateContactInput){
    status
  }
}
`
const updateIdentity = `
mutation updateIdentity($entityId: String!, $updateIdentityInput: updateIdentityInput!){
  updateIdentity(entityId: $entityId, updateIdentityInput: $updateIdentityInput){
    status
  }
}
`
const updateAddress = `
mutation updateAddress($entityId: String!, $updateAddressInput: updateAddressInput!){
  updateAddress(entityId: $entityId, updateAddressInput: $updateAddressInput){
    status
  }
}
`
const updateFact = `
mutation updateFact($entityId: String!, $updateFactInput: updateFactInput!){
  updateFact(entityId: $entityId, updateFactInput: $updateFactInput){
    status
  }
}
`

const updateIndividual = `
mutation updateIndividual($id: String!, $updateIndividualInput: updateIndividualInput!){
  updateIndividual(id: $id, updateIndividualInput: $updateIndividualInput){
    status
  }
}
`

const updateCompany = `
mutation updateCompany($id: String!, $updateCompanyInput: updateCompanyInput!){
  updateCompany(id: $id, updateCompanyInput: $updateCompanyInput){
    status
  }
}
`
const updateObject = `
mutation updateObject($id: String!, $updateObjectInput: updateObjectInput!){
  updateObject(id: $id, updateObjectInput: $updateObjectInput){
    status
  }
}
`

const updateInternal = `
mutation updateInternal($id:String! $updateInternalInput:updateInternalInput!){
  updateInternal(id:$id updateInternalInput:$updateInternalInput){
    status
    errors
  }
}
`

const updateOrganization = `
mutation updateOrganization($id:String! $updateOrganizationInput:updateOrganizationInput!){
  updateOrganization(id:$id updateOrganizationInput:$updateOrganizationInput){
    status
    errors
  }
}
`

const addClaimNote = `
mutation addClaimNote($claimId: ID! $input: addNoteInput!){
  addClaimNote(claimId: $claimId input: $input){
    errors
    status
  }
}
`

const updateClaimNote = `
mutation updateClaimNote($claimId: ID! $input: updateNoteInput!){
  updateClaimNote(claimId: $claimId input: $input){
    errors
    status
  }
}
`

const removeClaimNote = `
mutation removeClaimNote($claimId: ID! $noteId: ID!){
  removeClaimNote(claimId: $claimId noteId: $noteId){
    errors
    status
  }
}
`

const query = {
	insurers,
	products,
	internals,
	organizations,
	users,
	insuranceTypes,
	permissionGroups,
	individuals,
	companies
}

const mutation = {
	addPolicyNote,
	updatePolicyNote,
	deletePolicyNote,
	addEntityNote,
	updateEntityNote,
	deleteEntityNote,
	addNoteToCase,
	updateNoteOfCase,
	removeNoteFromCase,
	deletePolicyAttachment,
	deleteEntityAttachment,
	addContact,
	addIdentity,
	addAddress,
	addFact,
	addLink,
	deleteContact,
	deleteIdentity,
	deleteAddress,
	deleteFact,
	removeLink,
	updateContact,
	updateIdentity,
	updateAddress,
	updateFact,
	updateIndividual,
	updateCompany,
	updateObject,
	deleteFile,
	updateInternal,
	addClaimNote,
	updateClaimNote,
	removeClaimNote,
	updateOrganization
}

export { query, mutation }
